/* Local proposal only. No network, analytics, redirects or cart access.
   Use live product/variant data at integration time. Keep originalQuery unchanged.
   Budget result is a suggestion, not permission to relabel unfiltered results. */
(function(root){
'use strict';
const magic={productId:'8938538369297',handle:'sweetbox-magic',label:'SweetBox MAGIC'};
const aliases=new Set(['magic','מגיק','מאגיק','מג׳יק','מג\'יק'].map(normalize));
function normalize(value){return String(value).normalize('NFKC').trim().toLowerCase().replace(/[׳’']/g,'').replace(/\s+/g,' ');}
function inspect(value,options){
 const originalQuery=String(value),n=normalize(originalQuery);
 const aliasText=n.replace(/^(?:sweetbox|סוויטבוקס)\s+/,'');
 // Header-only opt-in: legacy discovery renders a fixed MAGIC card.
 const birthday=options&&options.headerAliases&&n==='האפי ברתדיי'?{productId:'11091550830865',handle:'סוויטבוקס-happy-birthday-מושלם-לימי-הולדת-xl',label:'SweetBox Happy Birthday'}:null;
 const productSuggestion=aliases.has(aliasText)?{...magic}:birthday;
 // One explicit amount only; no range inference or automatic currency conversion.
 const matches=[...originalQuery.matchAll(/(?:^|\s)(עד|under|up to)\s+(\d{1,4}(?:[.]\d{1,2})?)(?=\s|₪|$)/gi)];
 let budgetSuggestion=null;
 if(matches.length===1&&!/[$€£]|דולר|יורו|פאונד|\b(?:usd|eur|gbp|dollars?|euros?|pounds?)\b/i.test(originalQuery)){
  const [,operator,amount]=matches[0];
  const cents=Math.round(Number(amount)*100);
  // Reject competing amounts, negative prices and range-like syntax.
  const remaining=originalQuery.replace(matches[0][0],'');
  if(cents>0&&!/\d/.test(remaining)&&!/[−-]\s*$/.test(originalQuery.slice(0,matches[0].index))){
   budgetSuggestion={currency:'ILS',maxMinorUnits:cents,inclusive:operator.toLowerCase()!=='under',requiresExplicitApply:true};
  }
 }
 return {originalQuery,productSuggestion,budgetSuggestion};
}
const api={inspect,normalize};if(typeof module!=='undefined')module.exports=api;else root.SweetweetSearchIntent=api;
})(typeof globalThis!=='undefined'?globalThis:this);
